import styled from '@emotion/styled'
import { Typography } from 'antd'

export const CreatorTitle = styled(Typography.Title)`
  padding: 15px 0 0 15px;
  display: inline-block;
`
